import * as signalR from "@microsoft/signalr";
import {makeURL} from "@/tools/http";
import * as Sentry from "@sentry/vue";

let connection= null;
let connectTime = null;
const WS_TIME_LIMIT = () => (window.rsvWebsocketsTimeout || 3600) * 1000;

setInterval(() => {
    if (connection && connectTime) {
        const time = new Date().getTime();
        const diff = time - connectTime;

        if (diff >= WS_TIME_LIMIT()) {
            console.log('WS2: превышен лимит времени соединения');
            connection.stop();
            connection = null;
            connectTime = null;
        }
    }
}, 1000);

function connect(token) {
    return new Promise((resolve, reject) => {
        try {
            if (connection) {
                connection.stop();
                connection = null;
            }

            connection = new signalR.HubConnectionBuilder()
                .withUrl(
                    makeURL("ws2", "mainhub?group=general"),
                    {
                        accessTokenFactory: () => token,
                        withCredentials: false,
                        skipNegotiation: true,
                        transport: signalR.HttpTransportType.WebSockets,
                    }
                )
                .build()
            ;

            connection.onclose((e) => {
                console.log('WS2: Соединение закрыто', e);
            });

            connection
                .start()
                .then(() => {
                    console.log("WS2: Соединение установлено");
                    connectTime = new Date().getTime();
                    resolve();
                })
                .catch((error) => {
                    Sentry.captureException(error);
                    console.log("WS2: Ошибка соединения", error);
                    reject();
                });
        } catch (error) {
            Sentry.captureException(error);
            console.log('WS2: ', error);
            reject();
        }
    });

}

function setService(name, callback) {
    connection.on(name, message => {
        connectTime = new Date().getTime();
        const obj = {...message, payload: JSON.parse(message.payload)};
        callback(obj);
    });
}
function init(securityService) {
    return new Promise(resolve => {
        securityService.addUserListener(async (user) => {
            const token = user ? user.access_token : null;
            await connect(token);
            resolve();
        });
    });
}

export {
    setService,
    init,
};
